"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const InputLabel_1 = require("./InputLabel");
exports.default = InputLabel_1.InputLabel;
//# sourceMappingURL=index.js.map